import { observable, action, computed } from 'mobx'

import { StoreExt } from '@utils/reactExt'
import { LOCALSTORAGE_KEYS } from '@constants/index'
import { SOCKER_TYPES, DATA_FORMATS, SOCKET_TYPE, DATA_FORMAT_TYPE } from '@constants/socket'
import { oddsStore } from '@store/index'
import StorageUtils from '@utils/storage-utils'

export type SocketType = SOCKET_TYPE

export type DataFormatType = DATA_FORMAT_TYPE

export interface Message {
  event: string
  time?: number
  from: 'browser' | 'server' | 'console'
  data: any
}

/**
 * socket debugger store
 *
 * @export
 * @class SocketStore
 * @extends {StoreExt}
 */
export class SocketStore extends StoreExt {
  @observable
  // socketType: SocketType = (localStorage.getItem(LOCALSTORAGE_KEYS.SOCKET_TYPE) as SocketType) || SOCKER_TYPES[0]
  socketType: SocketType = SOCKER_TYPES[1]

  @observable
  dataFormat: DataFormatType =
  (localStorage.getItem(LOCALSTORAGE_KEYS.DATA_FORMAT) as DataFormatType) || DATA_FORMATS[0]

  @observable
  socketIsConnected = false

  @observable
  messages: Message[] = []

  @observable
  notSupportPolling: boolean = StorageUtils.isNotSupportPolling()

  constructor() {
    super()
    console.time('Mobx store initializing finished!!')
    console.time('Mobx store initializing - App index start')
    console.time('Mobx store initializing - PrimaryLayout constructor')
    console.time('Mobx store initializing - PrimaryLayout render start')
  }

  @computed
  get isSocketIO() {
    return this.socketType === SOCKER_TYPES[0]
  }

  @action
  setSocketType = (type: SocketType) => {
    this.socketType = type
  }

  @action
  setDataFormat = (dataFormat: DataFormatType) => {
    this.dataFormat = dataFormat
  }

  @action
  setSocketIsConnected = (socketIsConnected: boolean) => {
    this.socketIsConnected = socketIsConnected
  }

  @action
  clearMessages = () => {
    this.messages = []
  }

  @action
  addMessage = (message: Message) => {
    if (!message.time) {
      message.time = new Date().getTime()
    }
    // this.messages.push(message)
    this.messages = this.messages.concat([message])

    oddsStore.dispatchMessage(message)
  }

  @action
  setNotSupportPolling = (val: boolean) => {
    this.notSupportPolling = val
    StorageUtils.saveNotSupportPolling(val)
  }
}

export default new SocketStore()
